import Model from 'flarum/common/Model';
import mixin from 'flarum/common/utils/mixin';

export default class PostAdvcomment extends Model {
    advcomment = Model.hasOne('advcomment');

    userId = Model.attribute('userId');
    postId = Model.attribute('postId');
    advcommentId = Model.attribute('advcommentId');

    user = Model.hasOne('user');
    post = Model.hasOne('post');
};
// export default class PostAdvcomment extends mixin(Model, {
//     advcomment: Model.hasOne('advcomment'),
//
//     userId: Model.attribute('userId'),
//     postId: Model.attribute('postId'),
//     advcommentId: Model.attribute('advcommentId'),
//
//     user: Model.hasOne('user'),
//     post: Model.hasOne('post'),
// }) {}
